<div class="student-payments m-8" [ngClass]="{ 'mt-20': isMobile }">
  <div
    class="student-payments__top"
    [ngClass]="{ 'flex; justify-between': isMobile }"
  >
    <span class="student-payments__top__payment-text">Payments</span>
    <!-- mobile-view -->
    <div
      *ngIf="isMobile && invoiceInfoList.invoiceInfoList.length > 0"
      class="flex justify-between student-payments__top__payment-text"
    >
      <mat-icon class="cursor-pointer" (click)="onSwipe($event, -1, false)"
        >keyboard_arrow_left</mat-icon
      >
      <span class="student-payments__top__payment-text">{{
        index + 1 + "/" + invoiceInfoList.invoiceInfoList.length
      }}</span>
      <mat-icon class="cursor-pointer" (click)="onSwipe($event, 1, false)"
        >keyboard_arrow_right</mat-icon
      >
    </div>
  </div>
  <!-- desktop-view -->
  <div *ngIf="!isMobile" class="student-payments__body">
    <div
      class="student-payments__body__head"
      [ngClass]="{
        'student-payments__body__head__student': isStudent
      }"
    >
      <span *ngIf="!isStudent" class="student-payments__body__head__items"
        >Student</span
      >
      <span class="student-payments__body__head__items">Description</span>
      <span class="student-payments__body__head__items">Status</span>
      <span class="student-payments__body__head__items">Amount</span>
      <span class="student-payments__body__head__items">Paid Amount</span>
      <span class="student-payments__body__head__items">Due Amount</span>
      <span class="student-payments__body__head__items">Payment Method</span>
      <span class="student-payments__body__head__items">Due By</span>
      <!-- ** Not needed as of now -->
      <!-- <span class="student-payments__body__head__items">Paid For</span> -->
      <span></span>
    </div>
    <div
      *ngIf="invoiceInfoList.invoiceInfoList.length > 0"
      class="student-payments__body__content"
    >
      <div
        class="student-payments__body__content__container"
        [ngClass]="{
          'student-payments__body__content__container__student': isStudent
        }"
        *ngFor="
          let data of invoiceInfoList.invoiceInfoList;
          let invoiceIndex = index
        "
      >
        <span
          *ngIf="!isStudent"
          class="student-payments__body__content__container__items"
          >{{ data.studentName }}</span
        >
        <span class="student-payments__body__content__container__items">{{
          data.description
        }}</span>
        <span
          class="student-payments__body__content__container__items flex items-center gap-1"
          ><span
            class="{{
              'student-payments__body__content__container__items-payment-text-' +
                getRespectiveMatIconNameOrClassName(data.status, true)
            }} student-payments__body__content__container__items-payment-text"
            ><div class="block">
              <div>{{ getPaymentStatus(data.status) }}</div>
              <div
                *ngIf="
                  data.status === '8' ||
                  data.status === '11' ||
                  data.status === '5'
                "
                class="text-center"
              >
                {{ getPaymentSpan(data.status) }}
              </div>
            </div></span
          >
          <mat-icon
            [class]="
              'student-payments__body__content__container__items-payment-icon-' +
              getRespectiveMatIconNameOrClassName(data.status, true)
            "
            >{{
              getRespectiveMatIconNameOrClassName(data.status, false)
            }}</mat-icon
          >
        </span>
        <span class="student-payments__body__content__container__items">{{
          getAmountByDiscount(data.discount, data.amount, false, false)
        }}</span>
        <span class="student-payments__body__content__container__items">{{
          getAmountByDiscount(
            data.discount,
            data.amount,
            false,
            false,
            invoiceIndex,
            true
          )
        }}</span>
        <span class="student-payments__body__content__container__items">{{
          getAmountByDiscount(
            data.discount,
            data.amount,
            false,
            false,
            invoiceIndex,
            false,
            true
          )
        }}</span>
        <span class="student-payments__body__content__container__items">{{
          data.paymentTypeName
        }}</span>
        <span class="student-payments__body__content__container__items">{{
          data.dueDate
        }}</span>
        <!-- ** Not needed as of now -->
        <!-- <span class="student-payments__body__content__container__items">{{
          data.paidFor
        }}</span> -->
        <div class="flex items-center gap-3">
          <span
            *ngIf="checkPayNow(data.status)"
            (click)="openDueModal(data)"
            class="student-payments__body__content__container__items__icon"
            matTooltip="Pay Now"
          >
            <mat-icon>payment</mat-icon>
          </span>
          <span
            *ngIf="!checkPayNow(data.status) && data.status !== '5'"
            (click)="setPaymentHistory(invoiceIndex)"
            matTooltip="View Details"
          >
            <mat-icon
              class="student-payments__body__content__container__items__icon"
              >visibility</mat-icon
            ></span
          >
          <span
            *ngIf="data.paymentDetails.canShowUpdatePaymentMethodButton"
            (click)="updatePaymentMethod(data)"
            matTooltip="Update Payment Method"
          >
            <mat-icon
              class="student-payments__body__content__container__items__icon"
              >edit_square</mat-icon
            ></span
          >
        </div>
      </div>
      <!-- ** test code for expand each payment -->
      <!-- <div>
        <div class="flex flex-col gap-4 p-4">
          <div class="flex gap-4">
            <div class="flex gap-2">
              <span>Payment type :</span>
              <span>Installment</span>
            </div>
            <div class="flex gap-2">
              <span>Subscription Status : </span>
              <span>Active</span>
            </div>
          </div>
          <div>
            <div class="flex gap-4">
              <span style="min-width: 7rem">Installment</span>
              <span style="min-width: 70px">Date</span>
              <span style="min-width: 0px">Amount</span>
              <span>Status</span>
            </div>
            <div class="flex gap-4">
              <span style="min-width: 7rem">Installment 1</span>
              <span style="min-width: 70px">01/07/23</span>
              <span style="min-width: 70px">$320</span>
              <span>Paid</span>
            </div>
            <div class="flex gap-4">
              <span style="min-width: 7rem">Installment 1</span>
              <span style="min-width: 70px">01/07/23</span>
              <span style="min-width: 70px">$320</span>
              <span>Paid</span>
            </div>
            <div class="flex gap-4">
              <span style="min-width: 7rem">Installment 1</span>
              <span style="min-width: 70px">01/07/23</span>
              <span style="min-width: 70px">$320</span>
              <span>Paid</span>
            </div>
            <div class="flex gap-4">
              <span style="min-width: 7rem">Installment 1</span>
              <span style="min-width: 70px">01/07/23</span>
              <span style="min-width: 70px">$320</span>
              <span>Paid</span>
            </div>
            <div class="flex gap-4">
              <span style="min-width: 7rem">Installment 1</span>
              <span style="min-width: 70px">01/07/23</span>
              <span style="min-width: 70px">$320</span>
              <span>Paid</span>
            </div>
            <div class="flex gap-4">
              <span style="min-width: 7rem">Installment 1</span>
              <span style="min-width: 70px">01/07/23</span>
              <span style="min-width: 70px">$320</span>
              <span>Paid</span>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div
      *ngIf="invoiceInfoList.invoiceInfoList.length === 0 && !showLoader"
      style="height: 65vh; font-family: Montserrat"
      class="flex justify-center items-center font-bold text-slate-500 text-lg opacity-50"
    >
      No Data Available
    </div>
  </div>
  <div
    *ngIf="
      isMobile && invoiceInfoList.invoiceInfoList.length === 0 && !showLoader
    "
    style="height: 73vh; font-family: Montserrat"
    class="flex justify-center items-center font-bold text-slate-500 text-lg opacity-50"
  >
    No Data Available
  </div>
  <!-- mobile view -->
  <div
    *ngIf="
      isMobile &&
      mobileViewContent &&
      invoiceInfoList.invoiceInfoList.length > 0
    "
    class="pt-2 px-10"
    (swipe)="onSwipe($event, 0, true)"
  >
    <div *ngFor="let matcher of mobileViewCompareList" class="flex gap-4 mt-2">
      <span
        *ngIf="matcher !== 'Payment Method'"
        class="mobileView-name font-bold"
        [ngClass]="{ hidden: isStudent && matcher === 'Student' }"
        >{{ getMobileViewNameAndValue(matcher, true) }}</span
      >
      <span
        *ngIf="matcher === 'Payment Method'"
        class="mobileView-name font-bold"
        >Payment <br />
        Method</span
      >
      <span
        *ngIf="matcher !== 'Status'"
        [@cardAnimator]="animationState"
        (@cardAnimator.done)="resetAnimationState()"
        [ngClass]="{ hidden: isStudent && matcher === 'Student' }"
        >{{ getMobileViewNameAndValue(matcher, false) }}</span
      >
      <span
        [@cardAnimator]="animationState"
        (@cardAnimator.done)="resetAnimationState()"
        *ngIf="matcher === 'Status'"
        class="flex gap-2 items-center"
      >
        <span
          class="{{
            'student-payments__body__content__container__items-payment-text-' +
              getRespectiveMatIconNameOrClassName(
                mobileViewContent!.status,
                true
              )
          }} student-payments__body__content__container__items-payment-text"
          ><div class="block">
            <div>{{ getPaymentStatus(mobileViewContent!.status) }}</div>
            <div
              *ngIf="
                mobileViewContent!.status === '8' ||
                mobileViewContent!.status === '11' ||
                mobileViewContent!.status === '5'
              "
              class="text-center"
            >
              {{ getPaymentSpan(mobileViewContent!.status) }}
            </div>
          </div></span
        >
        <mat-icon
          [class]="
            'student-payments__body__content__container__items-payment-icon-' +
            getRespectiveMatIconNameOrClassName(mobileViewContent!.status, true)
          "
          >{{
            getRespectiveMatIconNameOrClassName(
              mobileViewContent!.status,
              false
            )
          }}</mat-icon
        >
      </span>
    </div>
    <div
      *ngIf="mobileViewContent"
      class="flex flex-col justify-center items-center gap-3 mt-8"
    >
      <span
        class="student-payments__body__content__container__pay-now-btn flex items-center gap-2"
        *ngIf="checkPayNow(mobileViewContent!.status)"
        (click)="openDueModal(mobileViewContent!)"
      >
        <span> Pay Now </span>
        <span><mat-icon>payment</mat-icon></span>
      </span>

      <span
        class="student-payments__body__content__container__pay-now-btn flex items-center gap-2"
        *ngIf="
          !checkPayNow(mobileViewContent!.status) &&
          mobileViewContent!.status !== '5'
        "
        (click)="setPaymentHistory(index)"
      >
        <span>Details </span>
        <span> <mat-icon>visibility</mat-icon></span>
      </span>

      <span
        class="student-payments__body__content__container__pay-now-btn flex items-center gap-2"
        *ngIf="
          mobileViewContent.paymentDetails.canShowUpdatePaymentMethodButton
        "
        (click)="updatePaymentMethod(mobileViewContent!)"
      >
        <span>Update Payment Method</span>
        <span><mat-icon>edit_square</mat-icon></span>
      </span>
    </div>
  </div>
</div>
<p-dialog
  [(visible)]="showDuePaymentModal"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  class="student-payment-dialog"
>
  <div class="paymentDueModal">
    <span class="paymentDueModal__pay-icon">
      <img src="assets/images/side-navbar/pay-1x.webp" />
    </span>
    <span class="paymentDueModal__fee-payment-due-text">Fee Payment Due</span>
    <span class="paymentDueModal__pay-warning"
      >Please pay immediately to continue.</span
    >
    <div class="paymentDueModal__box">
      <span class="paymentDueModal__box__amount">
        <span class="paymentDueModal__box__amount__text">Amount Due</span>
        <span class="paymentDueModal__box__amount__value">60 USD</span>
      </span>
      <span class="paymentDueModal__box__student-name">
        <span class="paymentDueModal__box__student-name__text"
          >Student Name</span
        >
        <span class="paymentDueModal__box__student-name__value">Ravi </span>
      </span>
      <span class="paymentDueModal__box__due-date">
        <span class="paymentDueModal__box__due-date__text">Due Date</span>
        <span class="paymentDueModal__box__due-date__value">23/ 05/ 2023 </span>
      </span>
      <span class="paymentDueModal__box__emi-payment">
        <span class="paymentDueModal__box__emi-payment__text">EMI Payment</span>
        <span class="paymentDueModal__box__emi-payment__value">Available</span>
      </span>
    </div>
    <span class="paymentDueModal__credit-card-accepted-text"
      >Credit Cards Accepted</span
    >
    <span class="paymentDueModal__pay-now-btn">Pay Now</span>
    <span class="paymentDueModal__view-previous-payment-text"
      >View my previous payments</span
    >
  </div>
</p-dialog>

<!-- ** Dialog for invoice if installment is allowed. -->
<p-dialog
  *ngIf="isInstallment"
  [class]="isMobile ? 'payNowDialog-mobile' : 'payNowDialog'"
  header="Pay Now"
  [(visible)]="isInstallment"
  [modal]="true"
  [draggable]="false"
>
  <div
    class="flex gap-2 items-center"
    [ngClass]="{ grid: isMobile }"
    *ngIf="selectedInvoice?.allowInstallment"
  >
    <span class="payNowDialog-paymentType-text">Select a payment type:</span>
    <div
      class="card flex justify-content-center"
      [ngClass]="{ 'w-max': isMobile }"
    >
      <p-selectButton
        class="payNowDialog-select"
        [ngClass]="{ 'payNowDialog-select-mobile': isMobile }"
        [options]="paymentOptions"
        [(ngModel)]="isPaymentOrInstallment"
        (ngModelChange)="termCheck1 = false"
        optionLabel="label"
        optionValue="value"
      ></p-selectButton>
    </div>
  </div>

  <!-- ** Installment Plan (MOnthly, Yearly etc .. ) -->
  <!-- <div>
      <span
        class="payNowDialog-installment-text"
        [ngClass]="{ 'payNowDialog-installment-text-mobile': isMobile }"
        >Select the Installment Plan</span
      >
      <mat-select
        [value]="installmentPlan"
        [(ngModel)]="installmentPlan"
        class="payNowDialog-installment-select"
        (selectionChange)="makeInstalmentDates()"
      >
        <ng-container *ngFor="let installmentOption of installmentOptions">
          <mat-option [value]="installmentOption.value">
            {{ installmentOption.displayValue }}
          </mat-option>
        </ng-container>
      </mat-select>
    </div> -->
  <div class="payNowDialog-invoice pt-2">
    <!-- <div class="payNowDialog-invoice-heading">INVOICE</div> -->
    <div
      *ngIf="isPaymentOrInstallment >= 0"
      class="payNowDialog-invoice-holder mt-2"
    >
      <div
        class="payNowDialog-invoice-header flex justify-between items-center"
        [ngClass]="{ 'py-1 px-4': isMobile, 'py-4 px-8': !isMobile }"
      >
        <span>INVOICE</span>
      </div>
      <div
        *ngIf="isPaymentOrInstallment === 0"
        class="flex flex-col pt-4 gap-8"
      >
        <!-- <div class=""> -->
        <!-- <div class="payNowDialog-invoice-heading px-8 pt-4">INVOICE</div> -->
        <div>
          <div class="payNowDialog-invoice-item payNowDialog-invoice-item-name">
            Due Amount
          </div>
          <div
            class="payNowDialog-invoice-item payNowDialog-invoice-item-value"
          >
            ${{ getAmountByInstallment(false) }}
          </div>
          <!-- <span
            *ngIf="installmentNumber > 3"
            class="payNowDialog-invoice-item payNowDialog-invoice-item-value"
          >
            * Inclusive 3% of Extra fee
          </span> -->
        </div>
        <div class="block">
          <div class="payNowDialog-invoice-item payNowDialog-invoice-item-name">
            Description
          </div>
          <div
            class="payNowDialog-invoice-item payNowDialog-invoice-item-value"
            [ngStyle]="{ 'font-size': isMobile ? '14px' : 'unset' }"
          >
            {{ selectedInvoice!.description }}
          </div>
        </div>
        <!-- <div class="block">
          <div class="payNowDialog-invoice-item payNowDialog-invoice-item-name">
            Student Name
          </div>
          <div
            class="payNowDialog-invoice-item payNowDialog-invoice-item-value"
          >
            {{ selectedInvoice!.studentName }}
          </div>
        </div> -->
        <div class="block">
          <div class="payNowDialog-invoice-item payNowDialog-invoice-item-name">
            Due Date
          </div>
          <div
            class="payNowDialog-invoice-item payNowDialog-invoice-item-value"
          >
            {{ selectedInvoice!.dueDate }}
          </div>
        </div>
        <div
          class="flex gap-2 px-2 text-justify items-baseline"
          [ngStyle]="{ 'font-size': isMobile ? '13px' : 'small' }"
        >
          <span
            [ngStyle]="{
              position: isMobile ? 'relative' : 'static',
              top: isMobile ? '4px' : '0px'
            }"
            >*</span
          >
          <span
            >I agree to pay the above mentioned amount in full and give a
            permission to Ravi's Academy to charge on the due date.</span
          >
        </div>
        <div class="flex justify-center gap-2 px-2">
          <mat-checkbox
            class="payNow-installment-checkbox"
            [(ngModel)]="termCheck1"
          ></mat-checkbox>
          <!-- <span>*</span> -->
          <div
            class="flex items-center"
            [ngStyle]="{ 'font-size': isMobile ? '13px' : 'normal' }"
          >
            <span>I Agree to pay</span>
          </div>
        </div>
        <div class="flex justify-center pb-4">
          <span
            class="payNowDialog-invoice-item-payNowBtn flex self-center"
            [ngClass]="{
              'payNowDialog-invoice-item-payNowBtn-mobile': isMobile,
              'payNowDialog-invoice-item-payNowBtn-invalid': !termCheck1
            }"
            (click)="installmentPay()"
          >
            Pay Now
          </span>
        </div>
        <!-- ** Installment End date -->
        <!-- <div *ngIf="isPaymentOrInstallment === 1" class="block pb-4">
          <div class="payNowDialog-invoice-item payNowDialog-invoice-item-name">
            Installment End Date
          </div>
          <div
            class="payNowDialog-invoice-item payNowDialog-invoice-item-value"
          >
            {{ installmentEndDate }}
          </div>
        </div> -->
      </div>
      <div
        *ngIf="isPaymentOrInstallment === 1"
        class="flex flex-col py-4 px-2"
        style="gap: 1rem"
      >
        <div *ngIf="!isMobile">
          <b>Total Amount to be paid </b> &nbsp; : ${{
            selectedInvoice!.transactionCharges === null ||
            selectedInvoice!.transactionCharges === 0
              ? getAmountByInstallment(true)
              : getTransactionCharge(true) +
                " " +
                " (Including transaction charges)"
          }}
        </div>
        <div *ngIf="isMobile" class="block">
          <div class="flex justify-center font-medium">
            Total Amount to be paid
          </div>
          <div
            *ngIf="selectedInvoice!.transactionCharges === 0"
            class="flex justify-center font-bold"
            style="font-size: 15px"
          >
            ${{ getAmountByInstallment(true) }}
          </div>
          <div
            *ngIf="selectedInvoice!.transactionCharges > 0"
            class="flex justify-center font-bold"
            style="font-size: 15px"
          >
            {{ "$" + getTransactionCharge(true) }}
          </div>
          <div
            *ngIf="selectedInvoice!.transactionCharges > 0"
            class="flex justify-center font-bold"
            style="font-size: 15px"
          >
            (Including transaction charges)
          </div>
        </div>
        <div class="flex gap-4" [ngClass]="{ grid: isMobile }">
          <div *ngIf="!isMobile" class="flex gap-4 items-center">
            <span
              class="payNowDialog-installment-text"
              [ngClass]="{ 'payNowDialog-installment-text-mobile': isMobile }"
              ><b>Total number of installments</b> : &nbsp;
              {{ selectedInvoice!.iterations }}
            </span>
            <!-- <span
              *ngIf="isMobile"
              class="payNowDialog-installment-text"
              [ngClass]="{ 'payNowDialog-installment-text-mobile': isMobile }"
              ><b>Total number of installments</b> : <br />{{
                selectedInvoice!.iterations
              }}<br />
            </span> -->
            <!-- <span>{{ selectedInvoice!.iterations }}</span> -->
            <!-- <mat-select
              [value]="installmentNumber"
              [(ngModel)]="installmentNumber"
              class="payNowDialog-installment-select"
              (selectionChange)="makeInstalmentDates()"
            >
              <ng-container *ngFor="let number of numbers">
                <mat-option
                  *ngIf="number <= selectedInvoice!.maxInstallment"
                  [value]="number"
                >
                  {{ number }}
                </mat-option>
              </ng-container>
            </mat-select> -->
          </div>
          <div *ngIf="isMobile" class="block">
            <div class="flex justify-center text-sm">
              Total number of Installments
            </div>
            <div class="flex justify-center text-md font-bold">
              {{ selectedInvoice!.iterations }}
            </div>
          </div>
        </div>
        <div class="flex justify-center gap-8">
          <div style="max-height: 9.5rem; overflow: auto; display: grid">
            <div
              class="flex p-2 font-bold text-sm"
              style="
                border: 1px solid black;
                background: #fff;
                position: sticky;
                top: 0;
              "
            >
              <span style="min-width: 7rem">Installments</span>
              <span style="min-width: 84px">Date</span>
              <span style="min-width: 84px">Amount</span>
              <span
                *ngIf="selectedInvoice!.transactionCharges"
                style="width: 100px; word-wrap: break-word"
                >Transaction Fee</span
              >
              <span
                *ngIf="selectedInvoice!.transactionCharges"
                style="min-width: 84px"
                >Total</span
              >
            </div>
            <div
              *ngFor="
                let installmentDate of installmentDates;
                let installmentIndex = index
              "
              class="flex p-2"
              style="
                font-size: 14px;
                min-width: 15rem;
                border: 1px solid black;
                border-top: 0px solid transparent;
              "
            >
              <!-- <div class="flex"> -->
              <div style="min-width: 7rem">
                {{ "Installment " + (installmentIndex + 1) }}
              </div>
              <!-- <div>:</div> -->
              <!-- </div> -->
              <!-- <div class="flex gap-4"> -->
              <div style="min-width: 84px">{{ installmentDate }}</div>
              <div style="min-width: 84px">
                ${{ getAmountByInstallment(false) }}
              </div>
              <div
                *ngIf="selectedInvoice!.transactionCharges"
                style="min-width: 100px"
              >
                ${{ selectedInvoice!.transactionCharges }}
              </div>
              <div
                *ngIf="selectedInvoice!.transactionCharges"
                style="min-width: 84px"
              >
                ${{
                  (
                    (selectedInvoice!.amount - selectedInvoice!.discount) /
                      selectedInvoice!.iterations +
                    selectedInvoice!.transactionCharges
                  ).toFixed(2)
                }}
              </div>
              <!-- </div> -->
            </div>
          </div>
        </div>
        <div
          *ngIf="selectedInvoice!.transactionCharges > 0"
          class="flex gap-2 px-2 text-justify items-baseline"
          [ngStyle]="{ 'font-size': isMobile ? '13px' : 'small' }"
        >
          <span
            [ngStyle]="{
              position: isMobile ? 'relative' : 'static',
              top: isMobile ? '4px' : '0px'
            }"
            >*</span
          >
          <span
            >For the installment option, an additional service charge mentioned
            above will be applied to every installment.</span
          >
        </div>
        <div
          class="flex gap-2 px-2 text-justify items-baseline"
          [ngStyle]="{ 'font-size': isMobile ? '13px' : 'small' }"
        >
          <span
            [ngStyle]="{
              position: isMobile ? 'relative' : 'static',
              top: isMobile ? '4px' : '0px'
            }"
            >*</span
          >
          <span
            >I agree to pay the above mentioned amount in installments and give
            a permission to Ravi's Academy to charge automatically on the due
            date for each installment.</span
          >
        </div>
        <div class="flex gap-2 px-2">
          <mat-checkbox
            class="payNow-installment-checkbox"
            [(ngModel)]="termCheck1"
          ></mat-checkbox>
          <!-- <span>*</span> -->
          <div
            class="flex items-center"
            [ngStyle]="{ 'font-size': isMobile ? '13px' : 'normal' }"
          >
            <span>I Agree to pay in Installments.</span>
            <!-- <span
              class="payNowDialog-installment-terms"
              (click)="showTAndCModal = true"
              >terms & conditions</span
            > -->
          </div>
        </div>
        <span
          class="payNowDialog-invoice-item-payNowBtn flex self-center"
          [ngClass]="{
            'payNowDialog-invoice-item-payNowBtn-invalid':
              !termCheck1 && isPaymentOrInstallment === 1,
            'payNowDialog-invoice-item-payNowBtn-mobile': isMobile
          }"
          (click)="installmentPay()"
        >
          {{ isPaymentOrInstallment === 1 ? "Subscribe" : "Pay Now" }}
        </span>
      </div>
    </div>
    <!-- <div class="payNowDialog-invoice-item">
      <span
        class="payNowDialog-invoice-item-payNowBtn"
        (click)="installmentPay()"
      >
        Pay Now
      </span>
    </div> -->
  </div>
</p-dialog>
<p-dialog
  *ngIf="showTAndCModal"
  [class]="isMobile ? 'payNowDialog-mobile' : 'payNowDialog'"
  header="Terms And Conditions"
  [(visible)]="showTAndCModal"
  [modal]="true"
  [draggable]="false"
>
  <div>
    <ul>
      <li>
        In the case of customer cancellations or return of items purchased on
        EMI, ASSPL will facilitate the refunds for and on behalf of the sellers
        as per the relevant refund policy. The customer is advised to check with
        the respective bank/issuer offering the EMI how the cancellations or
        refund will affect the EMI terms and of any pre-closure or interest
        charges levied on the customer.
      </li>
      <li>
        Any delay in payment of Monthly Instalment/EMI shall attract penal
        interest at the rate of 4% per month on the Monthly Instalment/EMI
        outstanding, from the date of default until the receipt of Monthly
        Instalment/EMI
      </li>
    </ul>
  </div>
</p-dialog>
<p-dialog
  [showHeader]="false"
  [resizable]="false"
  class="student-payments__loader"
  [(visible)]="showLoader || getPaymentUrlClicked"
  [modal]="true"
  [draggable]="false"
>
  <p-progressSpinner></p-progressSpinner>
</p-dialog>
<p-dialog
  *ngIf="paymentCardClicked"
  [resizable]="false"
  [ngClass]="{
    'paymentHistory-modal-sideNavCollapsed': isSideNavbarCollapsed && !isMobile,
    'paymentHistory-modal-sideNavFull': !isSideNavbarCollapsed && !isMobile,
    'paymentHistory-modal-mobile': isMobile
  }"
  header="Payment Info"
  [(visible)]="paymentCardClicked"
  [modal]="true"
  [draggable]="false"
>
  <div
    class="flex flex-col gap-8 font-mont"
    [ngClass]="{ 'px-4': isMobile, 'px-8': !isMobile }"
  >
    <!-- <div class="flex justify-between"> -->
    <!-- ** For Installment -->
    <!-- ** large screens -->
    <div
      *ngIf="paymentHistory?.paymentDetails?.isInstallmentPayment && !isMobile"
      class="flex flex-col gap-8"
    >
      <div class="flex gap-64">
        <div class="flex flex-col" style="gap: 18px">
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Payment Plan:</span>
            <span class="paymentHistory-modal-value">{{
              paymentHistory?.paymentDetails?.isInstallmentPayment
                ? "Installment"
                : "Full Payment"
            }}</span>
          </div>
          <div class="flex gap-2 items-center">
            <span class="paymentHistory-modal-key">Status:</span>
            <!-- <span>:</span> -->
            <div class="flex gap-2 items-center paymentHistory-modal-value">
              <span
                class="{{
                  'student-payments__body__content__container__items-payment-text-' +
                    getRespectiveMatIconNameOrClassName(
                      paymentHistory!.status,
                      true
                    )
                }} student-payments__body__content__container__items-payment-text-expanded"
              >
                <div class="flex gap-2">
                  <div>{{ getPaymentStatus(paymentHistory!.status) }}</div>
                  <!-- <div
                  *ngIf="
                    '8' === '8' ||
                    '8' === '11' ||
                    '8' === '5'
                  "
                  class="text-center"
                > -->
                  <div>
                    {{ getPaymentSpan(paymentHistory!.status) }}
                  </div>
                </div></span
              >
              <mat-icon
                [class]="
                  'student-payments__body__content__container__items-payment-icon-' +
                  getRespectiveMatIconNameOrClassName(
                    paymentHistory!.status,
                    true
                  )
                "
                >{{
                  getRespectiveMatIconNameOrClassName(
                    paymentHistory!.status,
                    false
                  )
                }}</mat-icon
              >
              <button
                mat-icon-button
                matTooltip="Checkout Invoice"
                (click)="checkoutInvoice(successfulTransactions[0])"
                *ngIf="
                  successfulTransactions[0]?.canDownloadInvoice &&
                  paymentHistory?.status === '3'
                "
              >
                <mat-icon>download_for_offline</mat-icon>
              </button>
            </div>
          </div>
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Amount:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              "$" + paymentHistory!.amount
            }}</span>
          </div>
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Final Amount:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              "$" + (paymentHistory!.amount - paymentHistory!.discount)
            }}</span>
          </div>
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Due Amount:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              "$" + getDueAmount()
            }}</span>
          </div>
          <!--<div class="flex gap-2">
            <span class="paymentHistory-modal-key">Paid On:</span>
            <!-- <span>:</span> ->
            <span class="paymentHistory-modal-value">{{
              paymentHistory!.paymentDetails.transactions[0]!.transactionDate
            }}</span>
          </div>-->
          <div
            *ngIf="
              paymentHistory!.paymentDetails.isInstallmentPayment &&
              successfulTransactions.length < paymentHistory!.iterations
            "
            class="flex gap-2"
          >
            <span class="paymentHistory-modal-key">Next Installment Date:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              nextInstallmentDate
            }}</span>
          </div>
        </div>
        <div class="flex flex-col" style="gap: 19px">
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Invoice ID:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-txn">{{
              paymentHistory!.invoiceId
            }}</span>
          </div>
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key"
              >Number of Payments Done:</span
            >
            <!-- <span>:</span> -->
            <span>{{
              successfulTransactions.length +
                " out of " +
                paymentHistory!.iterations
            }}</span>
          </div>
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Discount:</span>
            <!-- <span>:</span> -->
            <span>{{ "$" + paymentHistory!.discount.toFixed(2) }}</span>
          </div>
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Paid Amount:</span>
            <!-- <span>:</span> -->
            <span>{{ "$" + getPaidAmount() }}</span>
          </div>
          <div
            class="flex gap-2"
            *ngIf="paymentHistory?.paymentDetails?.isInstallmentPayment"
          >
            <span class="paymentHistory-modal-key">Transaction Charges:</span>
            <!-- <span>:</span> -->
            <span>{{
              "$" +
                paymentHistory!.transactionCharges *
                  successfulTransactions.length
            }}</span>
          </div>
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Due By:</span
            ><span>{{ paymentHistory!.dueDate }}</span>
          </div>
          <div
            *ngIf="
              paymentHistory!.paymentDetails.isInstallmentPayment &&
              successfulTransactions.length > 0
            "
            class="flex gap-2"
          >
            <span class="paymentHistory-modal-key">Last Installment Date:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              successfulTransactions[successfulTransactions.length - 1]
                .transactionDate
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- ** small screens -->
    <div
      *ngIf="paymentHistory?.paymentDetails?.isInstallmentPayment && isMobile"
      class="flex flex-col gap-8"
    >
      <div class="flex">
        <div class="flex flex-col" style="gap: 18px">
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Payment Plan:</span>
            <span class="paymentHistory-modal-value">{{
              paymentHistory?.paymentDetails?.isInstallmentPayment
                ? "Installment"
                : "Full Payment"
            }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Invoice ID:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-txn">{{
              paymentHistory!.invoiceId
            }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Status:</span>
            <!-- <span>:</span> -->
            <div class="flex gap-2 items-center paymentHistory-modal-value">
              <span
                class="{{
                  'student-payments__body__content__container__items-payment-text-' +
                    getRespectiveMatIconNameOrClassName(
                      paymentHistory!.status,
                      true
                    )
                }} student-payments__body__content__container__items-payment-text-expanded"
              >
                <div class="flex gap-2">
                  <div>{{ getPaymentStatus(paymentHistory!.status) }}</div>
                  <!-- <div
                  *ngIf="
                    '8' === '8' ||
                    '8' === '11' ||
                    '8' === '5'
                  "
                  class="text-center"
                > -->
                  <div>
                    {{ getPaymentSpan(paymentHistory!.status) }}
                  </div>
                </div></span
              >
              <mat-icon
                [class]="
                  'student-payments__body__content__container__items-payment-icon-' +
                  getRespectiveMatIconNameOrClassName(
                    paymentHistory!.status,
                    true
                  )
                "
                >{{
                  getRespectiveMatIconNameOrClassName(
                    paymentHistory!.status,
                    false
                  )
                }}</mat-icon
              >
              <button
                mat-icon-button
                matTooltip="Checkout Invoice"
                (click)="checkoutInvoice(successfulTransactions[0])"
                *ngIf="
                  successfulTransactions[0]?.canDownloadInvoice &&
                  paymentHistory?.status === '3'
                "
              >
                <mat-icon>download_for_offline</mat-icon>
              </button>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key"
              >Number of Payments Done:</span
            >
            <!-- <span>:</span> -->
            <span>{{
              successfulTransactions.length +
                " out of " +
                paymentHistory!.iterations
            }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Amount:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              "$" + paymentHistory!.amount
            }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Discount:</span>
            <!-- <span>:</span> -->
            <span>{{ "$" + paymentHistory!.discount.toFixed(2) }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Final Amount:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              "$" + (paymentHistory!.amount - paymentHistory!.discount)
            }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Paid Amount:</span>
            <!-- <span>:</span> -->
            <span>{{ "$" + getPaidAmount() }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Due Amount:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              "$" + getDueAmount()
            }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Transaction Charges:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              "$" +
                paymentHistory!.transactionCharges *
                  successfulTransactions.length
            }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Due By:</span
            ><span>{{ paymentHistory!.dueDate }}</span>
          </div>
          <!--<div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Paid On:</span>
            <!-- <span>:</span> ->
            <span class="paymentHistory-modal-value">{{
              paymentHistory!.paymentDetails.transactions[0]!.transactionDate
            }}</span>
          </div>-->
          <div
            *ngIf="
              paymentHistory!.paymentDetails.isInstallmentPayment &&
              successfulTransactions.length > 0
            "
            class="flex flex-col gap-2"
          >
            <span class="paymentHistory-modal-key">Last Installment Date:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              successfulTransactions[successfulTransactions.length - 1]
                .transactionDate
            }}</span>
          </div>
          <div
            *ngIf="
              paymentHistory!.paymentDetails.isInstallmentPayment &&
              successfulTransactions.length < paymentHistory!.iterations
            "
            class="flex flex-col gap-2"
          >
            <span class="paymentHistory-modal-key">Next Installment Date:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              nextInstallmentDate
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- ** For Full Payment -->
    <!-- ** large screens -->
    <div
      *ngIf="!paymentHistory?.paymentDetails?.isInstallmentPayment && !isMobile"
      class="flex flex-col gap-8"
    >
      <div class="flex gap-64">
        <div class="flex flex-col" style="gap: 18px">
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Payment Plan:</span>
            <span class="paymentHistory-modal-value">{{
              paymentHistory?.paymentDetails?.isInstallmentPayment
                ? "Installment"
                : "Full Payment"
            }}</span>
          </div>
          <div class="flex gap-2 items-center">
            <span class="paymentHistory-modal-key">Status:</span>
            <!-- <span>:</span> -->
            <div class="flex gap-2 items-center paymentHistory-modal-value">
              <span
                class="{{
                  'student-payments__body__content__container__items-payment-text-' +
                    getRespectiveMatIconNameOrClassName(
                      paymentHistory!.status,
                      true
                    )
                }} student-payments__body__content__container__items-payment-text-expanded"
              >
                <div class="flex gap-2">
                  <div>{{ getPaymentStatus(paymentHistory!.status) }}</div>
                  <!-- <div
                  *ngIf="
                    '8' === '8' ||
                    '8' === '11' ||
                    '8' === '5'
                  "
                  class="text-center"
                > -->
                  <div>
                    {{ getPaymentSpan(paymentHistory!.status) }}
                  </div>
                </div></span
              >
              <mat-icon
                [class]="
                  'student-payments__body__content__container__items-payment-icon-' +
                  getRespectiveMatIconNameOrClassName(
                    paymentHistory!.status,
                    true
                  )
                "
                >{{
                  getRespectiveMatIconNameOrClassName(
                    paymentHistory!.status,
                    false
                  )
                }}</mat-icon
              >
              <button
                mat-icon-button
                matTooltip="Checkout Invoice"
                (click)="checkoutInvoice(successfulTransactions[0])"
                *ngIf="
                  successfulTransactions[0]?.canDownloadInvoice &&
                  paymentHistory?.status === '3'
                "
              >
                <mat-icon>download_for_offline</mat-icon>
              </button>
            </div>
          </div>
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Discount:</span>
            <!-- <span>:</span> -->
            <span>{{ "$" + paymentHistory!.discount.toFixed(2) }}</span>
          </div>
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Paid Amount:</span>
            <!-- <span>:</span> -->
            <span>{{ "$" + getPaidAmount() }}</span>
          </div>
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Due By:</span
            ><span>{{ paymentHistory!.dueDate }}</span>
          </div>
        </div>
        <div class="flex flex-col" style="gap: 19px">
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Invoice ID:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-txn">{{
              paymentHistory!.invoiceId
            }}</span>
          </div>
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Amount:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              "$" + paymentHistory!.amount
            }}</span>
          </div>
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Final Amount:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              "$" +
                (paymentHistory!.amount - paymentHistory!.discount).toFixed(2)
            }}</span>
          </div>
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Due Amount:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              "$" + getDueAmount()
            }}</span>
          </div>
          <div class="flex gap-2">
            <span class="paymentHistory-modal-key">Paid On:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              paymentHistory!.paymentDetails.transactions[0]!.transactionDate
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- ** small screens -->
    <div
      *ngIf="!paymentHistory?.paymentDetails?.isInstallmentPayment && isMobile"
      class="flex flex-col gap-8"
    >
      <div class="flex gap-64">
        <div class="flex flex-col" style="gap: 18px">
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Payment Plan:</span>
            <span class="paymentHistory-modal-value">{{
              paymentHistory?.paymentDetails?.isInstallmentPayment
                ? "Installment"
                : "Full Payment"
            }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Invoice ID:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-txn">{{
              paymentHistory!.invoiceId
            }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Status:</span>
            <!-- <span>:</span> -->
            <div class="flex gap-2 items-center paymentHistory-modal-value">
              <span
                class="{{
                  'student-payments__body__content__container__items-payment-text-' +
                    getRespectiveMatIconNameOrClassName(
                      paymentHistory!.status,
                      true
                    )
                }} student-payments__body__content__container__items-payment-text-expanded"
              >
                <div class="flex gap-2">
                  <div>{{ getPaymentStatus(paymentHistory!.status) }}</div>
                  <!-- <div
                  *ngIf="
                    '8' === '8' ||
                    '8' === '11' ||
                    '8' === '5'
                  "
                  class="text-center"
                > -->
                  <div>
                    {{ getPaymentSpan(paymentHistory!.status) }}
                  </div>
                </div></span
              >
              <mat-icon
                [class]="
                  'student-payments__body__content__container__items-payment-icon-' +
                  getRespectiveMatIconNameOrClassName(
                    paymentHistory!.status,
                    true
                  )
                "
                >{{
                  getRespectiveMatIconNameOrClassName(
                    paymentHistory!.status,
                    false
                  )
                }}</mat-icon
              >
              <button
                mat-icon-button
                matTooltip="Checkout Invoice"
                (click)="checkoutInvoice(successfulTransactions[0])"
                *ngIf="
                  successfulTransactions[0]?.canDownloadInvoice &&
                  paymentHistory?.status === '3'
                "
              >
                <mat-icon>download_for_offline</mat-icon>
              </button>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Amount:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              "$" + paymentHistory!.amount
            }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Discount:</span>
            <!-- <span>:</span> -->
            <span>{{ "$" + paymentHistory!.discount.toFixed(2) }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Final Amount:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              "$" +
                (paymentHistory!.amount - paymentHistory!.discount).toFixed(2)
            }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Paid Amount:</span>
            <!-- <span>:</span> -->
            <span>{{ "$" + getPaidAmount() }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Due Amount:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              "$" + getDueAmount()
            }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Due By:</span
            ><span>{{ paymentHistory!.dueDate }}</span>
          </div>
          <div class="flex flex-col gap-2">
            <span class="paymentHistory-modal-key">Paid On:</span>
            <!-- <span>:</span> -->
            <span class="paymentHistory-modal-value">{{
              paymentHistory!.paymentDetails.transactions[0]!.transactionDate
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- ** payment history cards -->
    <!-- ** for large screens -->
    <div
      *ngIf="!isMobile && paymentHistory?.paymentDetails?.isInstallmentPayment"
      class="flex flex-col gap-8 max-h-64 overflow-auto px-2 pb-2"
    >
      <div
        *ngFor="
          let historyCard of paymentHistory?.paymentDetails?.transactions;
          let historyIndex = index
        "
        class="flex justify-between items-center paymentHistory-modal-history-card p-3"
      >
        <div style="min-width: 17.986px">{{ historyIndex + 1 }}</div>
        <div style="min-width: 101.545px">
          {{
            historyCard?.paymentStatus === 15
              ? "Refund"
              : "Installment " + (historyIndex + 1)
          }}
        </div>
        <div
          *ngIf="
            historyCard.paymentStatus !== 4 && historyCard.paymentStatus !== 9;
            else failedTransaction
          "
        >
          {{
            historyCard.amountReceived !== 0
              ? "$" +
                (historyCard.amountReceived < 0
                  ? -historyCard.amountReceived -
                    (historyCard?.paymentStatus === 15 &&
                    paymentHistory!.transactionCharges > 0
                      ? paymentHistory!.transactionCharges
                      : 0)
                  : historyCard.amountReceived
                ).toFixed(2)
              : "No Amount"
          }}
          {{
            historyCard?.paymentStatus === 15 && historyCard.amountReceived < 0
              ? paymentHistory!.transactionCharges > 0
                ? " + $" + paymentHistory!.transactionCharges
                : ""
              : historyCard.transactionCharges > 0
                ? " + $" + historyCard.transactionCharges
                : ""
          }}
        </div>
        <ng-template #failedTransaction><div></div></ng-template>
        <div>{{ historyCard.transactionDate }}</div>
        <div>
          <span>Stripe ID: </span>
          <span class="paymentHistory-modal-txn">{{
            historyCard.sessionId
          }}</span>
        </div>
        <div class="flex gap-2 items-center">
          <span
            class="{{
              'student-payments__body__content__container__items-payment-text-' +
                getRespectiveMatIconNameOrClassName(
                  historyCard!.paymentStatus,
                  true
                )
            }} student-payments__body__content__container__items-payment-text"
          >
            <div class="block">
              <div>{{ getPaymentStatus(historyCard!.paymentStatus) }}</div>
              <div
                *ngIf="
                  historyCard!.paymentStatus === 8 ||
                  historyCard!.paymentStatus === 11 ||
                  historyCard!.paymentStatus === 5
                "
                class="text-center"
              >
                {{ getPaymentSpan(historyCard!.paymentStatus) }}
              </div>
            </div></span
          >
          <mat-icon
            [class]="
              'student-payments__body__content__container__items-payment-icon-' +
              getRespectiveMatIconNameOrClassName(
                historyCard!.paymentStatus,
                true
              )
            "
            >{{
              getRespectiveMatIconNameOrClassName(
                historyCard!.paymentStatus,
                false
              )
            }}</mat-icon
          >
        </div>
        <button
          mat-icon-button
          matTooltip="Download Invoice"
          (click)="downloadInvoice(historyCard)"
          *ngIf="historyCard?.canDownloadInvoice"
        >
          <mat-icon>download_for_offline</mat-icon>
        </button>
      </div>
    </div>
    <!-- ** for small screens -->
    <div
      *ngIf="isMobile && paymentHistory?.paymentDetails?.isInstallmentPayment"
      class="flex flex-col gap-8 max-h-64 overflow-auto pb-2"
    >
      <div
        *ngFor="
          let historyCard of paymentHistory?.paymentDetails?.transactions;
          let historyIndex = index
        "
        class="paymentHistory-modal-history-card p-3"
      >
        <div class="flex">
          <div>
            <div style="min-width: 17.986px">{{ historyIndex + 1 }}.</div>
          </div>
          <div class="flex flex-col">
            <div style="min-width: 101.545px">
              {{
                historyCard?.paymentStatus === 15
                  ? "Refund"
                  : "Installment " + (historyIndex + 1)
              }}
            </div>
            <div
              *ngIf="
                historyCard.paymentStatus !== 4 &&
                  historyCard.paymentStatus !== 9;
                else failedTransaction
              "
            >
              {{
                historyCard.amountReceived !== 0
                  ? "$" +
                    (historyCard.amountReceived < 0
                      ? -historyCard.amountReceived -
                        (historyCard?.paymentStatus === 15 &&
                        paymentHistory!.transactionCharges > 0
                          ? paymentHistory!.transactionCharges
                          : 0)
                      : historyCard.amountReceived
                    ).toFixed(2)
                  : "No Amount"
              }}
              {{
                historyCard?.paymentStatus === 15 &&
                historyCard.amountReceived < 0
                  ? paymentHistory!.transactionCharges > 0
                    ? " + $" + paymentHistory!.transactionCharges
                    : ""
                  : historyCard.transactionCharges > 0
                    ? " + $" + historyCard.transactionCharges
                    : ""
              }}
            </div>
            <ng-template #failedTransaction><div></div></ng-template>
            <div>{{ historyCard.transactionDate }}</div>
            <div>
              <span>Stripe ID: </span>
              <span class="paymentHistory-modal-txn">{{
                historyCard.sessionId
              }}</span>
            </div>
            <div class="flex gap-2 items-center">
              <span
                class="{{
                  'student-payments__body__content__container__items-payment-text-' +
                    getRespectiveMatIconNameOrClassName(
                      historyCard!.paymentStatus,
                      true
                    )
                }} student-payments__body__content__container__items-payment-text"
              >
                <div class="block">
                  <div>{{ getPaymentStatus(historyCard!.paymentStatus) }}</div>
                  <div
                    *ngIf="
                      historyCard!.paymentStatus === 8 ||
                      historyCard!.paymentStatus === 11 ||
                      historyCard!.paymentStatus === 5
                    "
                    class="text-center"
                  >
                    {{ getPaymentSpan(historyCard!.paymentStatus) }}
                  </div>
                </div></span
              >
              <mat-icon
                [class]="
                  'student-payments__body__content__container__items-payment-icon-' +
                  getRespectiveMatIconNameOrClassName(
                    historyCard!.paymentStatus,
                    true
                  )
                "
                >{{
                  getRespectiveMatIconNameOrClassName(
                    historyCard!.paymentStatus,
                    false
                  )
                }}</mat-icon
              >
              <button
                mat-icon-button
                matTooltip="Download Invoice"
                (click)="downloadInvoice(historyCard)"
                *ngIf="historyCard?.canDownloadInvoice"
              >
                <mat-icon>download_for_offline</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div *ngIf="isMobile">
      <div
        *ngFor="
          let historyCard of paymentHistory?.paymentDetails?.transactions;
          let historyIndex = index
        "
        class="flex justify-between items-center paymentHistory-modal-history-card p-3"
        [ngClass]="{
          hidden:
            historyCard.paymentStatus === 10 || historyCard.paymentStatus === 6
        }"
      ></div>
    </div> -->
  </div>
</p-dialog>
